(function () {
  // wait until Splide exists
  function onSplideReady(cb) {
    if (window.Splide) return cb();
    const t = setInterval(() => {
      if (window.Splide) {
        clearInterval(t);
        cb();
      }
    }, 50);
  }

  onSplideReady(() => {
    const mounted = new Map();

    function isSearchSlider(sliderEl) {
      return !!sliderEl.closest(".ns-autocomplete-products");
    }

    function getViewByFromUI(root = document) {
      const activeBtn = root.querySelector(".ns-view-modes .ns-view-mode.active");
      if (!activeBtn) return null;
      const v = activeBtn.textContent.trim().toLowerCase();
      if (v === "model" || v === "item") return v;
      return null;
    }

    function reorderSlidesByView(sliderEl, viewBy) {
      const listEl = sliderEl.querySelector(".splide__list");
      if (!listEl) return;

      const slides = Array.from(listEl.children).filter(
        (el) => !el.classList.contains("splide__slide--clone")
      );

      const modelSlides = [];
      const itemSlides = [];

      for (let i = 0; i < slides.length; i++) {
        const s = slides[i];
        const t = (s.getAttribute("data-view") || "").toLowerCase();
        if (t === "item") itemSlides.push(s);
        else modelSlides.push(s);
      }

      const ordered =
        viewBy === "item"
          ? itemSlides.concat(modelSlides)
          : modelSlides.concat(itemSlides);

      for (let i = 0; i < ordered.length; i++) listEl.appendChild(ordered[i]);
    }

    function syncProgressBoxes(boxesEl) {
      if (!boxesEl) return;
      const boxes = Array.from(boxesEl.querySelectorAll(".progress-box"));
      for (let i = 0; i < boxes.length; i++) {
        boxes[i].dataset.index = String(i);
        boxes[i].classList.toggle("current", i === 0);
      }
    }

    function initSlider(sliderEl) {
      if (!sliderEl || sliderEl.dataset.splideMounted === "true") return;
      sliderEl.dataset.splideMounted = "true";

      const isSearch = isSearchSlider(sliderEl);

      // Scope everything to the card/container this slider belongs to (CRITICAL for Nosto)
      const card =
        sliderEl.closest(".plp-product-card-slider-container") ||
        sliderEl.closest(".plp-product-card-container") ||
        sliderEl.parentElement;

      const boxesEl =
        card?.querySelector(".card-images-boxes, .plp-card-images-boxes") || null;
      const prevBtn = card?.querySelector(".card-btn.prev") || null;
      const nextBtn = card?.querySelector(".card-btn.next") || null;

      // Only NON-search sliders should follow viewBy reorder rules
      if (!isSearch) {
        const initialView = getViewByFromUI(document) || "model";
        reorderSlidesByView(sliderEl, initialView);
        syncProgressBoxes(boxesEl);
      } else {
        syncProgressBoxes(boxesEl);
      }

      const boxes = boxesEl ? Array.from(boxesEl.querySelectorAll(".progress-box")) : [];

      const splide = new window.Splide(sliderEl, {
        type: "loop",
        perPage: 1,
        arrows: false,
        pagination: false,
        drag: true,
        keyboard: true,
        autoplay: false,
        speed: 600,
        lazyLoad: 'nearby',
      });

      const setProgressState = (index) => {
        if (!boxes.length) return;
        const safe = Math.max(0, Math.min(index, boxes.length - 1));
        for (let i = 0; i < boxes.length; i++) {
          boxes[i].classList.toggle("current", i === safe);
        }
      };

      splide.on("mounted", () => setProgressState(splide.index));
      splide.on("moved", () => setProgressState(splide.index));

      boxes.forEach((box) => {
        const go = () => splide.go(Number(box.dataset.index));
        box.addEventListener("click", go);
        box.addEventListener("keydown", (e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            go();
          }
        });
      });

      if (prevBtn) prevBtn.addEventListener("click", () => splide.go("<"));
      if (nextBtn) nextBtn.addEventListener("click", () => splide.go(">"));

      splide.mount();
      mounted.set(sliderEl, { splide, boxesEl, isSearch });
    }

    function initAll(root = document) {
      // Broader selector: ANY splide inside product cards (includes Nosto search cards too)
      const sliders = root.querySelectorAll(
        ".plp-product-card-slider-container .splide, .plp-product-card-container .splide"
      );
      sliders.forEach(initSlider);
    }

    function applyViewByToAll(viewBy) {
      mounted.forEach(({ splide, boxesEl, isSearch }, sliderEl) => {
        if (!sliderEl.isConnected) {
          mounted.delete(sliderEl);
          return;
        }

        // viewBy must NOT affect search sliders
        if (isSearch) return;

        reorderSlidesByView(sliderEl, viewBy);
        syncProgressBoxes(boxesEl);
        splide.refresh();
        splide.go(0);
      });
    }

    document.addEventListener("DOMContentLoaded", () => initAll());

    // ViewBy click listener still exists, but it only affects non-search sliders
    document.addEventListener("click", (e) => {
      const btn = e.target.closest(".ns-view-modes .ns-view-mode");
      if (!btn) return;
      const viewBy = btn.textContent.trim().toLowerCase();
      if (viewBy !== "model" && viewBy !== "item") return;
      applyViewByToAll(viewBy);
    });

    // Observe async injections (Nosto search results, etc.)
    const observer = new MutationObserver((mutations) => {
      for (const m of mutations) {
        for (const node of m.addedNodes) {
          if (!(node instanceof HTMLElement)) continue;

          if (
            node.querySelector?.(
              ".plp-product-card-slider-container .splide, .plp-product-card-container .splide"
            ) ||
            node.matches?.(".plp-product-card-slider-container, .plp-product-card-container")
          ) {
            initAll(node);
          }
        }
      }
    });

    observer.observe(document.documentElement, { childList: true, subtree: true });
  });
})();
